import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitleCommon, {DialogCloseCommon} from "./DialogTitleCommon";
import {FormButton} from "components/FormComponents/Button/FormButton";
import DialogContent from "@mui/material/DialogContent";
import {CPSConstants} from "commonUtils/enumerations";
import {dashBoardMessageStyle} from "features/Dashboard/components/DashboardMessages/dashBoardMesssageStyle";
import type {MessageDataProps} from "features/Dashboard/components/DashboardMessages/dashBoardMesssageStyle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import {format} from "date-fns";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import DOMPurify from "dompurify";
import {isValidObject} from "commonUtils/utils";

interface Props {
  announcementdialogopen: boolean;
  announceDialogData: MessageDataProps[];
  setAnnounceDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openAttachment: (id: number) => void;
  handleDelete: (id: number, type: string) => void;
}

const MessageCenterViewDialog: React.FC<Props> = ({
  announcementdialogopen,
  announceDialogData,
  setAnnounceDialogOpen,
  openAttachment,
  handleDelete,
}) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          minWidth: "70rem",
          minHeight: "20rem",
          "& .MuiDialogContent-root": {
            p: "20px !important",
          },
        },
      }}
      open={announcementdialogopen}>
      <DialogTitleCommon title="Show Announcement" />
      <DialogCloseCommon
        onClick={() => {
          setAnnounceDialogOpen(false);
        }}
      />
      <DialogContent>
        <Grid container spacing={0}>
          <Grid>
            <Grid item xs={12}>
              <Typography
                fontSize={CPSConstants.FONTREMHEAD}
                fontWeight={CPSConstants.FONTWEIGHT}
                component="div"
                sx={dashBoardMessageStyle.firstParaStyle}>
                {announceDialogData[0]?.subject}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                fontSize={CPSConstants.FONTREMHEAD}
                fontWeight={CPSConstants.FONTWEIGHT}
                component="div"
                sx={dashBoardMessageStyle.secondHeadingStyle}>
                Date :{" "}
                {isValidObject(announceDialogData[0]?.sentWhen)
                  ? format(
                      new Date(announceDialogData[0]?.sentWhen),
                      "MM/dd/yyyy",
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                fontSize={CPSConstants.FONTREMHEAD}
                fontWeight={CPSConstants.FONTWEIGHT}
                component="div"
                sx={dashBoardMessageStyle.secondHeadingStyle}>
                Sent By : {announceDialogData[0]?.sentBy}
              </Typography>
            </Grid>
            <br></br>
            <Box
              className="message-center-content"
              sx={{
                border: "1px solid gray",
                padding: "0.5rem",
                minWidth: "65.8rem",
                minHeight: "10rem",
              }}>
              <Box sx={dashBoardMessageStyle.marginTopOneStyle}>
                <Typography
                  component="span"
                  sx={dashBoardMessageStyle.completedTextStyle}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(announceDialogData[0]?.content),
                  }}></Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
                marginTop: "2rem",
              }}
              padding={2}>
              <Stack direction="row" spacing={2}>
                {announceDialogData[0]?.filePath && (
                  <FormButton
                    variant="contained"
                    size="small"
                    onClick={() => {
                      openAttachment(announceDialogData[0]?.announcementKey);
                    }}
                    outlet="View Attachment"
                  />
                )}
                <FormButton
                  variant="contained"
                  size="small"
                  onClick={() => {
                    setAnnounceDialogOpen(false);
                  }}
                  outlet="Close"
                />
                <FormButton
                  variant="contained"
                  size="small"
                  onClick={() => {
                    handleDelete(announceDialogData[0]?.announcementKey, "");
                  }}
                  outlet="Delete"
                />
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default MessageCenterViewDialog;
